import { __ } from "@wordpress/i18n";
import { useBlockProps, RichText } from "@wordpress/block-editor";
import { TextControl } from "@wordpress/components";

export default function Edit(props) {
	const blockProps = useBlockProps();

	return (
		<div {...blockProps}>
			<ul className="accordion js-accordion accordion-animate">
				<li className="accordion__item accordion__item--is-open js-accordion__item">
					{props.isSelected ? (
						<button
							className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
							type="button"
						>
							<span className="text-md a3w-accordion-question">
								<TextControl
									className="a3w-accordion-question"
									placeholder={__("Titre de l'accordéon", "a3web-blocks")}
									value={props.attributes.question}
									onChange={(question) => props.setAttributes({ question })}
								/>
							</span>

							<svg
								class="icon accordion__icon-arrow no-js:is-hidden"
								viewBox="0 0 16 16"
								aria-hidden="true"
							>
								<g
									class="icon__group"
									fill="none"
									stroke="currentColor"
									stroke-linecap="square"
									stroke-miterlimit="10"
								>
									<path d="M2 2l12 12" />
									<path d="M14 2L2 14" />
								</g>
							</svg>
						</button>
					) : (
						<button
							className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
							type="button"
						>
							<span className="text-md font-bold a3w-accordion-question">
								{props.attributes.question}
							</span>

							<svg
								className="icon accordion__icon-plus no-js:is-hidden"
								aria-hidden="true"
								viewBox="0 0 16 16"
								height="24"
								width="24"
							>
								<g
									className="icon__group"
									fill="none"
									stroke="currentColor"
									stroke-miterlimit="10"
								>
									<line x1="1" y1="8" x2="15" y2="8" />
									<line x1="1" y1="8" x2="15" y2="8" />
								</g>
							</svg>
						</button>
					)}

					{props.isSelected ? (
						<div className="accordion__panel js-accordion__panel">
							<div className="text-component padding-top-xxxs padding-x-md padding-bottom-md">
								<p className="a3w-accordion-answer">
									<RichText
										className="a3w-accordion-question"
										withoutInteractiveFormatting
										type="text"
										value={props.attributes.answer}
										onChange={(answer) => props.setAttributes({ answer })}
										placeholder={__("Contenu caché", "a3web-blocks")}
										tagName="div"
										multiline="p"
									/>
								</p>
							</div>
						</div>
					) : (
						<div className="accordion__panel js-accordion__panel">
							<div className="text-component padding-top-xxxs padding-x-md padding-bottom-md">
								<RichText.Content
									tagName="div"
									className="a3w-accordion-answer"
									value={props.attributes.answer}
								/>
							</div>
						</div>
					)}
				</li>
			</ul>
		</div>
	);
}
